// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

// @ utils
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const InsuranceRequestWizardStep3LinkTooltip = require('./insuranceRequestWizardStep3LinkTooltip');

class InsuranceRequestWizardStep3Tooltips extends React.Component {
    constructor(props) {
        super(props);

        this.wizardType = props.isRelated ? 'insuranceRelatedRequest' : 'insuranceRequestHome';
    }

    buildTooltip(link, content) {
        const { isPostAppraisal, onHandleTooltipMouseOver, onHandleTooltipMouseOut } = this.props;

        return (
            <InsuranceRequestWizardStep3LinkTooltip
                link={link}
                content={content}
                isPostAppraisal={isPostAppraisal}
                onHandleTooltipMouseOver={onHandleTooltipMouseOver}
                onHandleTooltipMouseOut={onHandleTooltipMouseOut}
            />
        );
    }

    buildHandsAtHomeTooltip() {
        const handsAtHomeLinkName = formatText('insuranceRequestHome-step3HandsAtHomeLink');
        const handsAtHomeContent = {
            title: handsAtHomeLinkName,
            message: <FormattedText value={`${this.wizardType}-step3HandsAtHomeContent`} />,
            className: 'icon-manitas insurance-request-wizard-step-three__icon-title'
        };

        return this.buildTooltip(handsAtHomeLinkName, handsAtHomeContent);
    }

    buildInformaticAssistanceTooltip() {
        const informaticAssistanceLinkName = formatText('insuranceRequestHome-step3InformaticAssistanceLink');
        const informaticAssistanceContent = {
            title: formatText('insuranceRequestHome-step3InformaticAssistanceTitle'),
            message: formatText('insuranceRequestHome-step3InformaticAssistanceContent'),
            className: 'icon-asistencia-informatica insurance-request-wizard-step-three__icon-title'
        };

        return this.buildTooltip(informaticAssistanceLinkName, informaticAssistanceContent);
    }

    render() {
        const messageFirstPart = `${formatText('insuranceRequestHome-step3HandsAtHomeText')} `;
        const messageConnector = ` ${formatText('insuranceRequestHome-step3HandsAtHomeConnector')} `;
        const messageLastPart = `${formatText('insuranceRequestHome-step3HandsAtHomeLastText')}`;

        const handsAtHomeTooltip = this.buildHandsAtHomeTooltip();
        const informaticAssistanceTooltip = this.buildInformaticAssistanceTooltip();

        return (
            <div className="insurance-request-wizard-step-three__box-info-content-bottom">
                <p className="insurance-request-wizard-step-three__text-bottom">
                    {messageFirstPart}
                    {handsAtHomeTooltip}
                    {messageConnector}
                    {informaticAssistanceTooltip}
                    {messageLastPart}
                </p>
            </div>
        );
    }
}

InsuranceRequestWizardStep3Tooltips.propTypes = {
    isRelated: PropTypes.bool,
    isPostAppraisal: PropTypes.bool,
    onHandleTooltipMouseOver: PropTypes.func,
    onHandleTooltipMouseOut: PropTypes.func
};

InsuranceRequestWizardStep3Tooltips.defaultProps = {
    isRelated: false,
    isPostAppraisal: false
};

module.exports = InsuranceRequestWizardStep3Tooltips;
